/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentVerificationStatusEnum } from './DocumentVerificationStatusEnum';
import {
    DocumentVerificationStatusEnumFromJSON,
    DocumentVerificationStatusEnumFromJSONTyped,
    DocumentVerificationStatusEnumToJSON,
    DocumentVerificationStatusEnumToJSONTyped,
} from './DocumentVerificationStatusEnum';
import type { FileTypeEnum } from './FileTypeEnum';
import {
    FileTypeEnumFromJSON,
    FileTypeEnumFromJSONTyped,
    FileTypeEnumToJSON,
    FileTypeEnumToJSONTyped,
} from './FileTypeEnum';

/**
 * 
 * @export
 * @interface StoredFileIdResponse
 */
export interface StoredFileIdResponse {
    /**
     * 
     * @type {string}
     * @memberof StoredFileIdResponse
     */
    storedFileId: string;
    /**
     * 
     * @type {FileTypeEnum}
     * @memberof StoredFileIdResponse
     */
    fileType: FileTypeEnum;
    /**
     * 
     * @type {DocumentVerificationStatusEnum}
     * @memberof StoredFileIdResponse
     */
    verificationStatus?: DocumentVerificationStatusEnum;
}



/**
 * Check if a given object implements the StoredFileIdResponse interface.
 */
export function instanceOfStoredFileIdResponse(value: object): value is StoredFileIdResponse {
    if (!('storedFileId' in value) || value['storedFileId'] === undefined) return false;
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    return true;
}

export function StoredFileIdResponseFromJSON(json: any): StoredFileIdResponse {
    return StoredFileIdResponseFromJSONTyped(json, false);
}

export function StoredFileIdResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoredFileIdResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'storedFileId': json['storedFileId'],
        'fileType': FileTypeEnumFromJSON(json['fileType']),
        'verificationStatus': json['verificationStatus'] == null ? undefined : DocumentVerificationStatusEnumFromJSON(json['verificationStatus']),
    };
}

export function StoredFileIdResponseToJSON(json: any): StoredFileIdResponse {
    return StoredFileIdResponseToJSONTyped(json, false);
}

export function StoredFileIdResponseToJSONTyped(value?: StoredFileIdResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'storedFileId': value['storedFileId'],
        'fileType': FileTypeEnumToJSON(value['fileType']),
        'verificationStatus': DocumentVerificationStatusEnumToJSON(value['verificationStatus']),
    };
}

